module.exports = __webpack_public_path__ + "img/error.d7d4712e.png";